export default __webpack_public_path__ + "static/media/hemsruti3.cca5e8d6.jpeg";